import React from 'react';

const AdminDetailList = ({ rows }) => (
  <div className="admin-detail-list">
    {rows.map(({ label, value }) => (
      <div key={label} className="admin-detail-row">
        <span className="admin-detail-label">{label}</span>
        <span className="admin-detail-value">{value}</span>
      </div>
    ))}
  </div>
);

export default AdminDetailList;
